import axios from 'axios'
// Tell Vue to use the plugin

export const HTTP_SOCKET = axios.create({
  baseURL: process.env.VUE_APP_socketserver
})
